import React from 'react';
import { PayCorrectionCustomVizDefinition } from 'libs/end-to-end/src/custom-viz/PayCorrectionDefinition';
import { CustomViz } from 'apps/sigma2-ui/src/components/custom-viz/CustomViz';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { PayCorrectionInterface } from 'apps/sigma2-ui/src/pay-correction/components/PayCorrectionInterface';
import { CalibrationFraming } from 'libs/end-to-end/src/calibration-framing';
import { MyObservation } from 'libs/end-to-end/src/my-observation';

export const PayCorrectionView = ({
  myObservation,
  organizationId,
  calibrationFraming,
}: {
  myObservation: MyObservation;
  organizationId: string;
  calibrationFraming: CalibrationFraming;
}) => {
  const { userAuthenticatedApiCall } = useUser();

  return (
    <CustomViz
      observation={myObservation.type}
      organizationId={organizationId}
      customVizDefinition={PayCorrectionCustomVizDefinition}
      userAuthenticatedApiCall={userAuthenticatedApiCall}
    >
      <PayCorrectionInterface
        observation={myObservation}
        organizationId={organizationId}
        userAuthenticatedApiCall={userAuthenticatedApiCall}
        calibrationFraming={calibrationFraming}
      />
    </CustomViz>
  );
};
